export class AmountUtils {
  static formatAmount(amount: number | undefined, currency: string) {
    if (amount === null || typeof amount === 'undefined') return amount;
    const c = currency ? currency + ' ' : '';
    const absAmount = amount >= 0 ? amount : -amount;
    const d = Math.floor(absAmount);
    const arr = Array.from(d.toString())
      .reverse()
      .join('')
      .match(/\d{1,3}/g);
    const n = arr ? arr.join(',').split('').reverse().join('') : '';
    const sign = amount >= 0 ? '' : '-';
    const p = Math.round((absAmount - d) * 100);
    return `${c}${sign}${n}.${p < 10 ? '0' : ''}${p}`;
  }
}
